var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 2.34c0-.98.77-1.55 1.7-1.27l7.2 2.16V17l-7.2-2.15a2.53 2.53 0 0 1-1.7-2.3V2.35Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18.78 2.34c0-.98-.77-1.55-1.7-1.27l-7.2 2.16V17l7.2-2.15c.94-.29 1.7-1.31 1.7-2.3V2.35Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgBook;